import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'extractText'
})
export class ExtractTextPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) return ''; // Handle null/undefined cases
    const match = value.match(/\(([^)]+)\)/); // Regex to extract text inside parentheses
    return match ? match[1] : value; // Return the extracted text or the original value
  }

}
